import {useEffect, useState, useCallback} from 'react';

import {
  getHubConnectionId,
  getHubConnectionState,
  invokeAPI,
  removeEventListener,
  sendAPI,
  subscribeEventListener,
} from '@/websocket/signalRManager';

import {SignalRHub} from '../constants/dataEnum';

const useHub = (hubName = SignalRHub.DEVICE) => {
  const [state, setState] = useState('');
  const [connectionId, setConnectionId] = useState(null);

  useEffect(() => {
    setState(getHubConnectionState(hubName));
    setConnectionId(getHubConnectionId(hubName));
  }, [hubName]);

  const invoke = useCallback((type = '', ...args) => invokeAPI(hubName, type, ...args), [hubName]);

  const send = useCallback((type = '', ...args) => sendAPI(hubName, type, ...args), [hubName]);

  const on = useCallback(
    (type = '', callback = () => {}) => {
      try {
        subscribeEventListener(hubName, type, callback);
      } catch (error) {
        console.error('useHub on', error);
        setTimeout(() => {
          on(type, callback);
        }, 200);
      }
    },
    [hubName],
  );

  const off = useCallback((type = '') => removeEventListener(hubName, type), [hubName]);

  return {
    invoke,
    send,
    on,
    off,
    state,
    connectionId,
  };
};

export default useHub;
